export const typedFromEntries = <K extends PropertyKey, V>(
  entries: Iterable<readonly [K, V]>,
  // oxlint-disable-next-line bank/no-object-from-entries -- this is the typed wrapper
): Record<K, V> => Object.fromEntries(entries) as Record<K, V>;
